import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const DesktopAi = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M14.447 18.21a.5.5 0 0 1 .544.452c.05.533.23.713.313.774a.4.4 0 0 0 .143.064h1.235a.5.5 0 1 1 0 1H8.909a.5.5 0 1 1 0-1h1.235-.003a.4.4 0 0 0 .146-.064c.083-.061.263-.24.313-.774a.5.5 0 0 1 .996.094 2.7 2.7 0 0 1-.17.744h2.738a2.7 2.7 0 0 1-.169-.744.5.5 0 0 1 .452-.545m6.053-2.875H5.09v1.222c0 .197.162.36.364.36h14.683a.363.363 0 0 0 .363-.36zm-9.16-7.67a2.08 2.08 0 0 1 1.455.597 2.07 2.07 0 0 1 1.452-.597l.043.001a2.22 2.22 0 0 1 1.456.718c.376.412.582.952.576 1.51 0 1.17-.796 2.156-1.53 2.803-.38.335-.774.605-1.104.795-.165.095-.32.173-.455.229a1.2 1.2 0 0 1-.437.108 1.2 1.2 0 0 1-.438-.108 4 4 0 0 1-.455-.229 7 7 0 0 1-1.103-.795c-.69-.607-1.432-1.511-1.523-2.586l-.008-.218c-.006-.557.2-1.096.575-1.508a2.22 2.22 0 0 1 1.454-.719l.021-.002zm2.892 1.001a1.08 1.08 0 0 0-.974.662l-.462 1.123-.463-1.123a1.07 1.07 0 0 0-.976-.662 1.21 1.21 0 0 0-1.089 1.222v.005c0 .724.516 1.457 1.193 2.053.327.288.665.52.94.679.138.08.255.137.34.173l.054.018.055-.018a3 3 0 0 0 .34-.173 6 6 0 0 0 .94-.679c.677-.596 1.192-1.328 1.192-2.052v-.006a1.21 1.21 0 0 0-1.09-1.222M5.017 2.912a.83.83 0 0 1 1.435 0l.06.126.83 2.162 2.102.852c.655.265.697 1.16.123 1.505l-.123.06-2.102.85-.83 2.164a.83.83 0 0 1-1.555 0l-.832-2.163-2.101-.85c-.698-.284-.699-1.283 0-1.566l2.102-.853.831-2.161zm.018 2.711a.85.85 0 0 1-.469.479V6.1l-1.811.733 1.812.734q.122.05.222.133l.064.059.056.065a1 1 0 0 1 .126.222l.698 1.818.7-1.82.035-.077a1 1 0 0 1 .15-.21L6.68 7.7q.1-.083.22-.132l1.812-.734L6.9 6.1a.83.83 0 0 1-.467-.479l-.699-1.82zM21.5 16.557c0 .753-.612 1.36-1.363 1.36H5.454a1.363 1.363 0 0 1-1.363-1.36v-4.519a.5.5 0 0 1 1 0v2.297H20.5V7.089a.363.363 0 0 0-.364-.362h-9.068a.5.5 0 1 1 0-1h9.068c.751 0 1.363.609 1.363 1.362z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(DesktopAi) as SvgIcon;
export { ForwardRef as ReactComponent };
